
/*global define*/

define('services/analyticsService',[
	'jquery'
], function($) {
	'use strict';

	var AnalyticsServices = {

		startTrackingCall: function(callData) {

			var BticinoDes = window.BticinoDes;

			if (callData) {
				
				ga('send', 'event', callData.category, callData.action, callData.opt_label, callData.opt_value, { 'nonInteraction': 1 });

			}
		},

		trackNumberOfCalls : function(numberOfCalls){
			var CallData = {
				category  : 'Informazioni generali',
				action    : 'numero appartamenti',
				opt_label : numberOfCalls,
				opt_value : undefined

			};
			this.startTrackingCall(CallData);
		},

		trackColorSelector : function(colorSelector){
			var CallData = {
				category  : 'Completamento impianto',
				action    : 'posti esterni - finitura',
				opt_label : colorSelector,
				opt_value : undefined

			};
			this.startTrackingCall(CallData);
		},
		
		trackCallModeSelector: function(callModeSelector){
			var CallData = {
				category  : 'Completamento impianto',
				action    : 'posti esterni - chiamata',
				opt_label : callModeSelector,
				opt_value : undefined

			};
			this.startTrackingCall(CallData);
		},

		trackNumberOfHandSets: function(numberOfHandSets){
			var CallData = {
				category  : 'Completamento impianto',
				action    : 'posti interni',
				opt_label : numberOfHandSets,
				opt_value : undefined

			};
			this.startTrackingCall(CallData);
		},

		trackTypeOfHandSet: function(typeOfHandset){
			var CallData = {
				category  : 'Completamento impianto',
				action    : 'posti interni - '+ typeOfHandset.name,
				opt_label : typeOfHandset.quantity,
				opt_value : undefined

			};
			this.startTrackingCall(CallData);
		},

		trackNumberOfQuote: function(){
			var CallData = {
				category  : 'Riepilogo',
				action    : 'numero di report',
				opt_label : 'Genera report',
				opt_value : undefined

			};
			this.startTrackingCall(CallData);
		},

		trackValueOfQuote: function(value){
			var CallData = {
				category  : 'Riepilogo',
				action    : 'preventivo',
				opt_label : value,
				opt_value : undefined

			};
			this.startTrackingCall(CallData);
		}

	};

	return AnalyticsServices;
});